// Public destination identifiers copied from the Royal Path Google interfaces.
// These are not credentials. No message, customer or payment data is sent.
export const measurementConfig = {
  analyticsTagId: "G-VMTYP12ZJV",
  adsTagId: "AW-18498226137",
  whatsappConversionTarget: "AW-18498226137/SBHkCIO-mpwdENmP0vRE",
  allowedOrigins: [
    "https://rpabugp.com",
    "https://www.rpabugp.com",
    "https://rpabugp.vercel.app",
  ],
} as const;

export const whatsAppPlacements = [
  "floating", "package-card", "package-detail", "contact-hero",
  "contact-support", "footer", "homepage-faq", "paddock-home", "paddock-catalogue",
] as const;
